import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GurmukhiWatermark } from './ui/Ornaments';
export const ForParents = () => {
  const chips = ['Confidence', 'Identity', 'Maturity', 'Leadership', 'Real-World Exposure', 'Network'];
  return <section className="py-24 bg-parchment relative overflow-hidden" data-id="element-110">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-111" />
      <GurmukhiWatermark text="ਸੇਵਾ" className="text-bronze -right-20 top-10 opacity-[0.03] rotate-12" data-id="element-112" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-113">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-115">
            <h2 className="font-serif text-3xl md:text-5xl text-navy mb-6" data-id="element-116">
              What your child will gain.
            </h2>
            <div className="pl-6 border-l-2 border-kesari mb-8 relative" data-id="element-117">
              <motion.div initial={{
              height: 0
            }} whileInView={{
              height: '100%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5
            }} className="absolute left-[-2px] top-0 w-[2px] bg-gold" data-id="element-118" />
              <p className="font-sans text-lg text-charcoal/80 italic" data-id="element-119">
                "We provide a safe, structured, and highly rigorous environment
                where students are treated as young adults capable of solving
                real problems. This is an investment in their maturity and
                future trajectory."
              </p>
            </div>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={{
          visible: {
            transition: {
              staggerChildren: 0.1
            }
          }
        }} className="flex flex-wrap gap-3" data-id="element-120">
            {chips.map(chip => <motion.div key={chip} variants={{
            hidden: {
              opacity: 0,
              scale: 0.8
            },
            visible: {
              opacity: 1,
              scale: 1
            }
          }} whileHover={{
            scale: 1.05,
            backgroundColor: 'var(--color-kesari)',
            color: 'var(--color-ivory)',
            borderColor: 'var(--color-kesari)'
          }} className="px-5 py-2 bg-ivory border border-bronze/30 rounded-full font-sans text-sm text-navy font-medium shadow-sm transition-colors cursor-default" data-id="element-121">
                {chip}
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
};